import { render, staticRenderFns } from "./banner-event-form.vue?vue&type=template&id=278cc1a3&"
import script from "./banner-event-form.vue?vue&type=script&lang=js&"
export * from "./banner-event-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports